import { useTranslation } from 'react-i18next';
import { useUpcomingEventsCount } from '@/hooks';
import { cn } from '@/lib/utils';

interface EventsNavBadgeProps {
  className?: string;
  active?: boolean;
}

export function EventsNavBadge({ className, active = false }: EventsNavBadgeProps) {
  const { t } = useTranslation();
  const { data } = useUpcomingEventsCount();
  const count = data?.meta?.total ?? 0;

  if (count <= 0) {
    return null;
  }

  const display = count > 9 ? '9+' : String(count);

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-[10px] font-bold leading-none',
        active
          ? 'bg-[#FBBF24] text-slate-900 ring-2 ring-white/80'
          : 'bg-[#1E40AF] text-white',
        className,
      )}
      aria-label={t('nav.eventsUpcomingBadge', { count })}
    >
      {display}
    </span>
  );
}
